import React, { useState, useEffect } from "react";
import LogProspektTable from "./components/LogProspektTable";
import Create from "./modals/CreateProspekt";
import FilterProspekt from "./modals/FilterProspekt";
import axios from "axios";
import Delete from "./modals/RemoveProspekt";
import { updateObject } from "../../../helpers/updateObject";
import ExportIcon from "@material-ui/icons/CloudDownload";
import Switch from "@material-ui/core/Switch/index";
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import TextField from "@material-ui/core/TextField/index";

export default function LogProspekt(props) {
  const {
    chooseDevicePlaceId,
    setChooseDevicePlaceId,
    isLoading,
    isError,
    setSortField,
    setOrderByTable,
    sortField,
    orderBy,
    count,
    skip,
    take,
    updateSkip,
    updateTake,
    setIsLoading,
    setIsError,
    setCount,
    showLog,
  } = props;

  const [logId, setLogId] = useState(undefined);
  const [showCreate, setShowCreate] = useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [structureId, setStructureId] = useState();
  const [showFilter, setShowFilter] = useState(false);
  const [logRows, setLogRows] = useState([]);
  const [logRows1, setLogRows1] = useState([]);

  const [searchField, setSearchField] = useState("");

  const [filterInputs, setFilterInputs] = useState({
    structureId: "",
  });

  function handleChange() {
    setShowFilter((key) => !key);
  }

  const onLogRows = () => {
    setIsLoading(true);
    const { structureId } = filterInputs;

    axios
      .get(
        `${
          process.env.REACT_APP_API_URL
        }structure/device-place/${chooseDevicePlaceId}?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}${
          structureId ? `&structureId=${structureId}` : ""
        }`
      )
      .then(({ data: { content, totalElements } }) => {
        setIsLoading(false);
        setLogRows(content);
        setIsError(false);
        setCount(totalElements);
      })
      .catch((error) => {
        setIsLoading(false);
        setIsError(true);
        setLogRows([]);
      });
  };

  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);
    updateSkip(0);
  };

  useEffect(() => {
    if (showLog) {
      onLogRows(orderBy, sortField, skip, take, filterInputs);
    }
  }, [orderBy, sortField, skip, take, showLog, filterInputs]);

  const onStructureProspectExport = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}structure/device-place/export?${
          chooseDevicePlaceId ? `id=${chooseDevicePlaceId}` : ""
        }`,

        {
          responseType: "blob",
        }
      )
      .then((res) => {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var a = document.createElement("a");
        a.href = url;
        a.download = "Structure-SAP-log.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  };

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}structure/select?source=PROSPECT_ProID`
      )
      .then((res) => {
        const structureId = res.data.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setStructureId(structureId);
      });
  }, []);

  const handleSearch = (e) => {
    setSearchField(e.target.value);
  };

  useEffect(() => {
    const filteredData = logRows.filter((logRow) =>
      logRow.structureName.toLowerCase().includes(searchField.toLowerCase())
    );
    setLogRows1(filteredData);

    console.log("searchFieldfvgerfervgfreagergd");
  }, [searchField]);

  return (
    <div className="row bg-white rounded SHADOW">
      <div className="row w-100  mt-3 justify-content-end">
        <div className=" col-3  d-flex justify-content-end">
          <TextField
            label="Struktur adı"
            className="w-100 ml-3"
            type="search"
            placeholder="Struktur adı"
            onChange={handleSearch}
          />
        </div>
        <div className="row col-9 w-100 justify-content-end">
          <div className=" col-3  d-flex justify-content-end">
            <FormControlLabel
              control={
                <Switch
                  checked={showFilter}
                  onChange={handleChange}
                  color="secondary"
                />
              }
              label={showFilter ? "Filtri gizlət" : "Filtri göstər"}
              className="ml-auto mb-0"
            />
          </div>
          <div className=" col-1 d-flex justify-content-end">
            <button
              className="btn btn-sm btn-icon btn-bg-light btn-text-success btn-hover-success mr-2 h5 rounded-circle flex-shrink-0"
              onClick={onStructureProspectExport}
            >
              <ExportIcon />
            </button>
          </div>
        </div>
      </div>

      <div className="col-12 d-flex  mt-3 ">
        <LogProspektTable
          logRows={logRows}
          logRows1={logRows1}
          searchField={searchField}
          chooseDevicePlaceId={chooseDevicePlaceId}
          setChooseDevicePlaceId={setChooseDevicePlaceId}
          setSortField={setSortField}
          setOrderByTable={setOrderByTable}
          sortField={sortField}
          orderBy={orderBy}
          updateSkip={updateSkip}
          updateTake={updateTake}
          count={count}
          setLogId={setLogId}
          logId={logId}
          setShowCreate={setShowCreate}
          isLoading={isLoading}
          isError={isError}
          setShowRemove={setShowRemove}
        />
      </div>

      {showCreate && (
        <Create
          structureId={structureId}
          logId={logId}
          id={chooseDevicePlaceId}
          onLogRows={onLogRows}
          show={showCreate}
          onHide={setShowCreate}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
        />
      )}
      {showRemove && (
        <Delete
          id={chooseDevicePlaceId}
          show={showRemove}
          onHide={setShowRemove}
          onLogRows={onLogRows}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          logId={logId}
        />
      )}
      <FilterProspekt
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
        structureId={structureId}
      />
    </div>
  );
}
